import type { OrganizationMetadata } from '@shared-types/organizations';
import type { CamelCaseKeys, OverrideRecordValueTypes } from './utility-types.ts';
import type { Tables } from '@/types/database.types.ts';
export interface Organization {
    id: string;
    metadata: OrganizationMetadata;
    status: 'active' | 'suspended';
    suspendedAt: string | null;
    suspendedBy: string | null;
    suspensionReason: string | null;
    autoDeleteAt: string | null;
}

export type OrganizationRow = CamelCaseKeys<OverrideRecordValueTypes<Tables<'organizations'>, { metadata: OrganizationMetadata }>>;

/** Shape of get_organization_public_metadata's response - fields deliberately safe for pre-auth (anon) callers. */
export interface OrganizationPublicMetadata {
    organizationId: string;
    name: string;
    branding: unknown;
    orgCode: string;
    contactUrl: string | null;
    defaultLanguage?: OrganizationMetadata['defaultLanguage'];
    languageRestrictions?: OrganizationMetadata['languageRestrictions'];
}
export type OrganizationRole = 'admin' | 'instructor' | 'manager' | 'department_admin' | 'participant';
export const ORGANIZATION_ROLES: OrganizationRole[] = ['admin', 'instructor', 'manager', 'department_admin', 'participant'];
export type PermissionRow = CamelCaseKeys<Tables<'permissions'>>;
export type RolePermissionRow = CamelCaseKeys<Tables<'role_permissions'>>;